import React, { useState, useEffect, useRef } from "react";
import styles from "./modal.module.scss";
import { NavLink, useNavigate } from "react-router-dom";
import { DeviceType } from "../../hooks/useRWD";
import useRWD from "../../hooks/useRWD";
import { useMutation } from "react-query";
import { LoginFormData } from "../../../models/registrationModel";
import loginService from "../../../service/login/login";
import { log } from "util";
import RecaptchaScriptLoader from '../../../service/reCaptcha/reCaptcha';
import reCaptchaApiService from '../../../service/reCaptcha/reCaptchaApiService';
import registratoionService from '../../../service/register/registration';
import MsgModal from "../../../componsnts/common/customModal/customModal";
import ReactLoading from 'react-loading';

interface CustomModalProps {
  isOpen: boolean;
  title: string;
  registrationLoaing: boolean;
  iAmBuyer?: boolean;
  iAmSeller?: boolean;
  onSubmit?: any;
}

// Be aware of ** 登入頁面不需要了，但程式碼還沒刪

const CustomModal: React.FC<CustomModalProps> = ({
  isOpen,
  title,
  iAmBuyer,
  iAmSeller,
  registrationLoaing,
  onSubmit,
}) => {
  const [modalTitle, setModalTitle] = useState(title);
  const [isBuyer, setIsBuyer] = useState(false);
  const [showBuyerSignUp, setShowBuyerSignUp] = useState(iAmBuyer);
  const [isSeller, setIsSeller] = useState(iAmSeller);
  const [isLogin, setIsLogin] = useState(false); // 2024-08-09 不需要登入畫面
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isMsgModalOpen, setIsMsgModalOpen] = useState(false);
  const [recaptchaLoading, setRecaptchaLoading] = useState(false);
  const [isRegistrationLoaing, setIsRegistrationLoaing] = useState(registrationLoaing);
  const [modalMessageOpen, setModalMessageOpen] = useState('');

  const device = useRWD();
  const [errors, setErrors] = useState<{ [key: string]: boolean }>({
    CompanyName: false,
    CompanyTax: false,
    ContacterName: false,
    ContacterPhone: false,
    Email: false,
    Password: false,
    ConfirmPassword: false,
  });
  const inputChanged = useRef(false);
  const [errorMessage, setErrorMessage] = useState({
    Password: "",
    ConfirmPassword: "",
    Email: "",
    CompanyAddress: "",
    ContacterPhone: "",
    ContacterName: "",
    CompanyTax: "",
    CompanyName: "",
  });


  // **********註冊事件 ＳＴＡＲＴ～～～～～～～
  const [confirmPassword, setConfirmPassword] = useState("");
  const [registrationFormData, setRegistrationFormData] = useState({
    AccountRole: 0,
    CompanyName: "",
    CompanyTax: "",
    ContacterName: "",
    ContacterPhone: "",
    Email: "",
    CompanyAddress: "",
    Password: "",
  });

  // 初始化 AccountRole
  useEffect(() => {
    // 08-09 新增進入後判斷用戶是甚麼身分
    if (!isLogin) {
      if (iAmSeller) {
        sellerSignUp()
      } else if (iAmBuyer) {
        buyerSignUp()
      }
    }
    setRegistrationFormData((prevData) => ({
      ...prevData,
      AccountRole: isBuyer ? 0 : 1,
    }));
  }, [isBuyer, iAmBuyer]);


  useEffect(() => {
    if (registrationLoaing) {
      setIsRegistrationLoaing(true)
    } else {
      setIsRegistrationLoaing(false)
    }

  }, [registrationLoaing])

  // {正則判斷} ~~~~~
  const allowedCharacters = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
  const texPattern = /^\d{8}$/;
  const phonePattern = /^09\d{8}$/;
  const telephone = /^0\d{8,9}$/;
  const emptyPattern = /\S/;
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const passwordPattern = (password: string): boolean => {
    if (password.length < 8) {
      return false;
    }

    const hasLowercase = /[a-z]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasDigit = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*]/.test(password);

    // 計算符合的字符類型數量
    const typesCount = [
      hasLowercase,
      hasUppercase,
      hasDigit,
      hasSpecialChar,
    ].filter(Boolean).length;

    return typesCount >= 3;
  };

  const isValidUnifiedNumber = (id: string): boolean => {
    if (!/^\d{8}$/.test(id)) return false;

    const weights = [1, 2, 1, 2, 1, 2, 4, 1];
    const digits = id.split('').map(Number);

    const sum = digits.reduce((acc, digit, i) => {
      const product = digit * weights[i];
      return acc + Math.floor(product / 10) + (product % 10);
    }, 0);

    const isValid = sum % 10 === 0;

    // 特例：第七碼為 7，總和 +1 可被 10 整除也算合法
    if (!isValid && digits[6] === 7) {
      return (sum + 1) % 10 === 0;
    }

    return isValid;
  };


  const handleChange = (e: any) => {
    inputChanged.current = true;
    setRegistrationFormData({
      ...registrationFormData,
      [e.target.name]: e.target.value,
    });
  };



  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const {
      CompanyName,
      CompanyTax,
      ContacterPhone,
      Email,
      CompanyAddress,
      Password,
      ContacterName,
    } = registrationFormData;

    // ****** 表單防呆判斷
    let hasErrors = false;
    if (Password !== confirmPassword || confirmPassword === "") {
      setErrorMessage(prevErrorMessages => ({
        ...prevErrorMessages,
        ConfirmPassword: "密碼和確認密碼不匹配",
      }));
      setErrors(preErrors => ({
        ...preErrors,
        ConfirmPassword: true,
      }));
      hasErrors = true;
    }

    if (!passwordPattern(Password)) {
      setErrorMessage(prevErrorMessages => ({
        ...prevErrorMessages,
        Password: "密碼需至少8位數，且符合數字、大寫英文字母、小寫英文字母、特殊字元或符號任三項",
      }));
      setErrors(preErrors => ({
        ...preErrors,
        Password: true,
      }));
      hasErrors = true;
    }

    if (!emailPattern.test(Email)) {
      setErrorMessage(prevErrorMessages => ({
        ...prevErrorMessages,
        Email: "信箱格式錯誤",
      }));
      setErrors(preErrors => ({
        ...preErrors,
        Email: true,
      }));
      hasErrors = true;
    }

    // 連絡電話不須驗證

    // if (!phonePattern.test(ContacterPhone) && !telephone.test(ContacterPhone)) {
    //   setErrorMessage(prevErrorMessages => ({
    //     ...prevErrorMessages,
    //     ContacterPhone: "請輸入正確的聯繫方式",
    //   }));
    //   setErrors(preErrors => ({
    //     ...preErrors,
    //     ContacterPhone: true,
    //   }));
    //   hasErrors = true;
    // }

    if (!emptyPattern.test(ContacterName)) {
      setErrorMessage(prevErrorMessages => ({
        ...prevErrorMessages,
        ContacterName: "姓名不能為空白",
      }));
      setErrors(preErrors => ({
        ...preErrors,
        ContacterName: true,
      }));
      hasErrors = true;
    }

    if (!emptyPattern.test(CompanyAddress)) {
      setErrorMessage(prevErrorMessages => ({
        ...prevErrorMessages,
        CompanyAddress: "發票地址不能為空白",
      }));
      setErrors(preErrors => ({
        ...preErrors,
        CompanyAddress: true,
      }));
      hasErrors = true;
    }

    if (!texPattern.test(CompanyTax)) {
      setErrorMessage(prevErrorMessages => ({
        ...prevErrorMessages,
        CompanyTax: "統編必須為 8 碼數字",
      }));
      setErrors(preErrors => ({
        ...preErrors,
        CompanyTax: true,
      }));
      hasErrors = true;
    } else if (!isValidUnifiedNumber(CompanyTax)) {
      setErrorMessage(prevErrorMessages => ({
        ...prevErrorMessages,
        CompanyTax: "統編格式錯誤，請重新輸入",
      }));
      setErrors(preErrors => ({
        ...preErrors,
        CompanyTax: true,
      }));
      hasErrors = true;
    }

    if (!allowedCharacters.test(CompanyName)) {
      setErrorMessage(prevErrorMessages => ({
        ...prevErrorMessages,
        CompanyName: "公司名稱包含無效字符或為空",
      }));
      setErrors(preErrors => ({
        ...preErrors,
        CompanyName: true,
      }));
      hasErrors = true;
    }


    if (hasErrors) {
      console.log('有錯誤');

      return;
    }
    // 通過驗證後繼續進行 reCaptcha 驗證
    setRecaptchaLoading(true)
    RecaptchaChecking()
  };

  const getInputStyle = (field: string) => {

    if (errors[field]) {
      return { border: '1px solid red', color: 'red' };
    } else {
      return {};
    }
  };

  const handleFocus = (field: string) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: false,
    }));
  };

  const handleBlur = (field: string, value: string) => {

    if (!inputChanged.current) {
      return
    }
    if (value.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: true,
      }));
    }
  };

  const resetErrorMessages = () => {
    setErrorMessage({
      Password: "",
      ConfirmPassword: "",
      Email: "",
      CompanyAddress: "",
      ContacterPhone: "",
      ContacterName: "",
      CompanyTax: "",
      CompanyName: "",
    })
  }

  const mesModal = (msg: string) => {
    setIsMsgModalOpen(true)
    setModalMessageOpen(msg)
  }

  const closeModal = () => {
    setIsMsgModalOpen(false);
  };

  //********** 註冊 ＥＮＤ～～～～～～～～ */

  //********** reCaptcha ＳＴＡＲＴ～～～～～～～～ */

  // 確保 reCAPTCHA 腳本已經加載
  const RecaptchaChecking = () => {
    if (window.grecaptcha) {
      console.log('reCAPTCHA is ready');
      grecaptcha.ready(function () {
        grecaptcha.execute('6LfeWokqAAAAACKFe67YIKiyYmWq1tqR8yrFM8T3', { action: 'submit' }).then(function (token) {
          if (token) {
            const tokenObject = { token: token }
            reCaptchaVerify(tokenObject)
          } else {
            console.log('reCaptcha缺少token');
          }
        });
      });
    } else {
      console.error('reCAPTCHA not loaded');
    }
  };

  const { mutate: reCaptchaVerify, } = useMutation({
    mutationFn: (token: Object) => reCaptchaApiService.reCaptchaVerify(token),
    onSuccess: (res) => {
      setRecaptchaLoading(false)
      if (!res.Data.success || res.Data.score < 0.5) {
        // 這邊被判定安全係數過低
        mesModal('您的電腦被判定為機器人。\n※請洽技術人員')
        return;
      } else {
        // 辨識成功後進一步驗證公司統編
        taxVerify(registrationFormData.CompanyTax)
      }
    },
    onError: (err) => {
      console.error("Error fetching reCaptcha:", err);
    },
  });

  const { mutate: taxVerify, isLoading: isTaxVerifyLoading } = useMutation({
    mutationFn: (tax: string) => registratoionService.taxVerify(tax),
    onSuccess: (res) => {
      if (res.Data) {
        resetErrorMessages()
        setRegistrationFormData({
          AccountRole: isBuyer ? 0 : 1,
          CompanyName: "",
          CompanyTax: "",
          ContacterName: "",
          ContacterPhone: "",
          Email: "",
          CompanyAddress: "",
          Password: "",
        })
        setConfirmPassword("")
        // 發射送出表單
        onSubmit(registrationFormData);
      } else {
        setErrorMessage(prevErrorMessages => ({
          ...prevErrorMessages,
          CompanyTax: "統一編號輸入錯誤，請重新輸入。",
        }));
        setErrors(preErrors => ({
          ...preErrors,
          CompanyTax: true,
        }));
      }

    },
    onError: (err) => {
      console.error("Error fetching taxVerify:", err);
    },
  });


  //********** reCaptcha Ｅ　Ｎ　Ｄ～～～～～～～～ */

  //********** 忘記密碼 ＳＴＡＲＴ～～～～～～～～ */
  const [forgotPassFormData, setForgotPassFormData] = useState({
    Email: "",
  });

  const handleForgotPassChange = (e: any) => {
    setForgotPassFormData({
      ...forgotPassFormData,
      [e.target.name]: e.target.value,
    });
  };

  const handleForgotPassSubmit = (e: any) => {
    e.preventDefault();
    forgotPass(forgotPassFormData)
  };

  const {
    mutate: forgotPass,
  } = useMutation({
    mutationFn: (data: any) => loginService.forgotPassword(data),
    onSuccess: (res) => {
      // console.log(res);
    },
    onError: (err) => {
      console.error("Error fetching forgotPassword data:", err);
    },
  });

  //********** 忘記密碼 ＥＮＤ～～～～～～～～ */

  const backWebUrl = process.env.REACT_APP_DA_CHAUNG_BACK_WEB_URL;
  const buyerSignUp = () => {
    setIsLogin(false);
    setIsBuyer(true);
    setModalTitle("我想買電");
    const modalContent = document.querySelector(".modal_content");
    modalContent?.classList.add("buyer");
  };

  const sellerSignUp = () => {
    setIsLogin(false);
    setIsSeller(true);
    setModalTitle("我想賣電");
    const modalContent = document.querySelector(".modal_content");
    modalContent?.classList.add("buyer");
  };

  const goToLogin = () => {
    window.open(backWebUrl, "_blank");
  };


  return (
    <div
      className={`${styles["custom_modal"]} ${isOpen ? styles["open"] : ""}`}

    >
      <MsgModal isOpen={isMsgModalOpen} onClose={closeModal} message={modalMessageOpen}></MsgModal>
      {device === DeviceType.PC && (
        <div className="slogan">
          <div className="slogan_text">
            RENEWABLE
            <span className="slogan_text_2">綠電交易平台</span>
          </div>
          <div className="slogan_text">ENERGY TRADING</div>
        </div>
      )}

      <div className="modal_content">
        <div className="title_box">
          <div className="title">
            {modalTitle ? modalTitle : "綠電交易平台"}
          </div>
        </div>



        {/* 買家 Modal */}
        {isBuyer === true && (
          <form onSubmit={handleSubmit} className="input_sec">
            <div className="buyer_title">歡迎加入大創綠電平台</div>
            <div className="input_box signUp row">
              <div className="signUp_box col-md-6 col-sm-12">
                <label className="sigup_label" htmlFor="account">
                  <img
                    className="sigup_icons"
                    src="/assets/images/modal/building.svg"
                    alt=""
                  />
                  <span className="label_text">公司名稱</span>
                  <span className="redColor">*</span>
                  {errorMessage.CompanyName && <span className="error_message">{errorMessage.CompanyName}</span>}
                </label>
                <input
                  id="companyName"
                  name="CompanyName"
                  value={registrationFormData.CompanyName}
                  onChange={handleChange}
                  onFocus={() => handleFocus('CompanyName')}
                  onBlur={() => handleBlur('CompanyName', registrationFormData.CompanyName)}
                  style={getInputStyle('CompanyName')}
                  type="text"
                  className="sigup_input"
                  placeholder="請輸入公司名稱"
                />
              </div>
              <div className="signUp_box col-md-6 col-sm-12">
                <label className="sigup_label" htmlFor="account">
                  <img
                    className="sigup_icons"
                    src="/assets/images/modal/ID.svg"
                    alt=""
                  />
                  <span className="label_text">統編</span>
                  <span className="redColor">*</span>
                  {errorMessage.CompanyTax && <span className="error_message">{errorMessage.CompanyTax}</span>}
                </label>
                <input
                  id="companyTax"
                  name="CompanyTax"
                  value={registrationFormData.CompanyTax}
                  onChange={handleChange}
                  onFocus={() => handleFocus('CompanyTax')}
                  onBlur={() => handleBlur('CompanyTax', registrationFormData.CompanyTax)}
                  style={getInputStyle('CompanyTax')}
                  type="text"
                  className="sigup_input"
                  placeholder="請輸入您的統編"
                />
              </div>
            </div>

            <div className="input_box signUp row">
              <div className="signUp_box col-md-6 col-sm-12">
                <label className="sigup_label" htmlFor="account">
                  <img
                    className="sigup_icons"
                    src="/assets/images/modal/user.svg"
                    alt=""
                  />
                  <span className="label_text">聯絡人姓名</span>
                  <span className="redColor">*</span>
                  {errorMessage.ContacterName && <span className="error_message">{errorMessage.ContacterName}</span>}
                </label>
                <input
                  id="contacterName"
                  name="ContacterName"
                  value={registrationFormData.ContacterName}
                  onChange={handleChange}
                  onFocus={() => handleFocus('ContacterName')}
                  onBlur={() => handleBlur('ContacterName', registrationFormData.ContacterName)}
                  style={getInputStyle('ContacterName')}
                  type="text"
                  className="sigup_input"
                  placeholder="請輸入您的姓名"
                />
              </div>
              <div className="signUp_box col-md-6 col-sm-12">
                <label className="sigup_label" htmlFor="account">
                  <img
                    className="sigup_icons"
                    src="/assets/images/modal/phone.svg"
                    alt=""
                  />
                  <span className="label_text">連絡電話</span>
                  <span className="redColor">*</span>
                  {errorMessage.ContacterPhone && <span className="error_message">{errorMessage.ContacterPhone}</span>}
                </label>
                <input
                  id="contacterPhone"
                  name="ContacterPhone"
                  value={registrationFormData.ContacterPhone}
                  onChange={handleChange}
                  onFocus={() => handleFocus('ContacterPhone')}
                  onBlur={() => handleBlur('ContacterPhone', registrationFormData.ContacterPhone)}
                  style={getInputStyle('ContacterPhone')}
                  type="text"
                  className="sigup_input"
                  placeholder="請輸入您的電話"
                />
              </div>
            </div>

            <div className="input_box signUp row">
              <div className="signUp_box col-12">
                <label className="sigup_label" htmlFor="account">
                  <img
                    className="sigup_icons"
                    src="/assets/images/modal/email.svg"
                    alt=""
                  />
                  <span className="label_text">聯絡人信箱</span>
                  <span className="redColor">*</span>
                  {errorMessage.Email && <span className="error_message">{errorMessage.Email}</span>}
                </label>
                <input
                  id="email"
                  name="Email"
                  type="email"
                  value={registrationFormData.Email}
                  onChange={handleChange}
                  onFocus={() => handleFocus('Email')}
                  onBlur={() => handleBlur('Email', registrationFormData.Email)}
                  style={getInputStyle('Email')}
                  className="sigup_email_input"
                  placeholder="請輸入您的信箱"
                />
                <label className="annotation">此為登入帳號</label>
              </div>
            </div>

            <div className="input_box signUp row">
              <div className="signUp_box col-12">
                <label className="sigup_label" htmlFor="account">
                  <img
                    style={{ width: '28px', height: '28px' }}
                    className="sigup_icons"
                    src="/assets/images/modal/address.png"
                    alt=""
                  />
                  <span className="label_text">發票地址</span>
                  <span className="redColor">*</span>
                  {errorMessage.CompanyAddress && <span className="error_message">{errorMessage.CompanyAddress}</span>}
                </label>
                <input
                  id="CompanyAddress"
                  name="CompanyAddress"
                  type="address"
                  value={registrationFormData.CompanyAddress}
                  onChange={handleChange}
                  onFocus={() => handleFocus('CompanyAddress')}
                  onBlur={() => handleBlur('CompanyAddress', registrationFormData.CompanyAddress)}
                  style={getInputStyle('CompanyAddress')}
                  className="sigup_address_input"
                  placeholder="請輸入您的發票地址"
                />
                {/* <label className="annotation">此為登入帳號</label> */}
              </div>
            </div>

            <div className="input_box signUp row">
              <div className="signUp_box col-md-6 col-sm-12">
                <label className="sigup_label" htmlFor="account">
                  <img
                    className="sigup_icons"
                    src="/assets/images/modal/key.svg"
                    alt=""
                  />
                  <span className="label_text">會員密碼</span>
                  <span className="redColor">*</span>
                </label>
                <input
                  id="password"
                  name="Password"
                  type="password"
                  value={registrationFormData.Password}
                  onChange={handleChange}
                  onFocus={() => handleFocus('Password')}
                  onBlur={() => handleBlur('Password', registrationFormData.Password)}
                  style={getInputStyle('Password')}
                  className="sigup_input"
                  placeholder="請輸入您的密碼"
                />
                <label className="annotation">
                  密碼需至少8位數，且符合數字、大寫英文字母、小寫英文字母、特殊字元或符號任三項即可
                </label>
              </div>
              <div className="signUp_box col-md-6 col-sm-12">
                <label className="sigup_label" htmlFor="account">
                  <img
                    className="sigup_icons"
                    src="/assets/images/modal/key.svg"
                    alt=""
                  />
                  <span className="label_text">確認會員密碼</span>
                  <span className="redColor">*</span>
                  {errorMessage.ConfirmPassword && <span className="error_message">{errorMessage.ConfirmPassword}</span>}
                </label>
                <input
                  id="confirmPassword"
                  name="ConfirmPassword"
                  type="password"
                  style={getInputStyle('ConfirmPassword')}
                  onFocus={() => handleFocus('ConfirmPassword')}
                  onBlur={() => handleBlur('ConfirmPassword', registrationFormData.Password)}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="sigup_input"
                  placeholder="請再次輸入您的密碼"
                />
              </div>
            </div>

            <div className="signUp_links_box">
              <button type="button" onClick={goToLogin} className="backToLogin">
                已經有帳號
              </button>

              <button type="submit" className="signUp_btn">
                {recaptchaLoading || isRegistrationLoaing || isTaxVerifyLoading ? (
                  <div className="btn_loading">
                    <ReactLoading type="spin" color="#00BFFF" height={30} width={30} />
                  </div>
                ) : (
                  '註冊'
                )}
              </button>
            </div>
          </form>
        )}

        {/* 賣家 Modal */}
        {isSeller === true && (
          <form onSubmit={handleSubmit} className="input_sec ">
            <div className="buyer_title">歡迎加入大創綠電平台</div>
            <div className="input_box signUp row">
              <div className="signUp_box col-6">
                <label className="sigup_label" htmlFor="account">
                  <img
                    className="sigup_icons"
                    src="/assets/images/modal/building.svg"
                    alt=""
                  />
                  <span className="label_text">公司名稱</span>
                  <span className="redColor">*</span>
                  {errorMessage.CompanyName && <span className="error_message">{errorMessage.CompanyName}</span>}
                </label>
                <input
                  id="companyName"
                  name="CompanyName"
                  value={registrationFormData.CompanyName}
                  onChange={handleChange}
                  onFocus={() => handleFocus('CompanyName')}
                  onBlur={() => handleBlur('CompanyName', registrationFormData.CompanyName)}
                  style={getInputStyle('CompanyName')}
                  type="text"
                  className="sigup_input"
                  placeholder="請輸入公司名稱"
                />
              </div>
              <div className="signUp_box col-6">
                <label className="sigup_label" htmlFor="account">
                  <img
                    className="sigup_icons"
                    src="/assets/images/modal/ID.svg"
                    alt=""
                  />
                  <span className="label_text">統編</span>
                  <span className="redColor">*</span>
                  {errorMessage.CompanyTax && <span className="error_message">{errorMessage.CompanyTax}</span>}
                </label>
                <input
                  id="companyTax"
                  name="CompanyTax"
                  value={registrationFormData.CompanyTax}
                  onChange={handleChange}
                  onFocus={() => handleFocus('CompanyTax')}
                  onBlur={() => handleBlur('CompanyTax', registrationFormData.CompanyTax)}
                  style={getInputStyle('CompanyTax')}
                  type="text"
                  className="sigup_input"
                  placeholder="請輸入公司統編"
                />
              </div>
            </div>

            <div className="input_box signUp row">
              <div className="signUp_box col-md-6 col-sm-12">
                <label className="sigup_label" htmlFor="account">
                  <img
                    className="sigup_icons"
                    src="/assets/images/modal/user.svg"
                    alt=""
                  />
                  <span className="label_text">聯絡人姓名</span>
                  <span className="redColor">*</span>
                  {errorMessage.ContacterName && <span className="error_message">{errorMessage.ContacterName}</span>}
                </label>
                <input
                  id="contacterName"
                  name="ContacterName"
                  value={registrationFormData.ContacterName}
                  onChange={handleChange}
                  onFocus={() => handleFocus('ContacterName')}
                  onBlur={() => handleBlur('ContacterName', registrationFormData.ContacterName)}
                  style={getInputStyle('ContacterName')}
                  type="text"
                  className="sigup_input"
                  placeholder="請輸入您的姓名"
                />
              </div>
              <div className="signUp_box col-md-6 col-sm-12">
                <label className="sigup_label" htmlFor="account">
                  <img
                    className="sigup_icons"
                    src="/assets/images/modal/phone.svg"
                    alt=""
                  />
                  <span className="label_text">連絡電話</span>
                  <span className="redColor">*</span>
                  {errorMessage.ContacterPhone && <span className="error_message">{errorMessage.ContacterPhone}</span>}
                </label>
                <input
                  id="contacterPhone"
                  name="ContacterPhone"
                  value={registrationFormData.ContacterPhone}
                  onChange={handleChange}
                  onFocus={() => handleFocus('ContacterPhone')}
                  onBlur={() => handleBlur('ContacterPhone', registrationFormData.ContacterPhone)}
                  style={getInputStyle('ContacterPhone')}
                  type="text"
                  className="sigup_input"
                  placeholder="請輸入您的電話"
                />
              </div>
            </div>

            <div className="input_box signUp row">
              <div className="signUp_box col-12">
                <label className="sigup_label" htmlFor="account">
                  <img
                    className="sigup_icons"
                    src="/assets/images/modal/email.svg"
                    alt=""
                  />
                  <span className="label_text">聯絡人信箱</span>
                  <span className="redColor">*</span>
                  {errorMessage.Email && <span className="error_message">{errorMessage.Email}</span>}
                </label>
                <input
                  id="email"
                  name="Email"
                  type="email"
                  value={registrationFormData.Email}
                  onChange={handleChange}
                  onFocus={() => handleFocus('Email')}
                  onBlur={() => handleBlur('Email', registrationFormData.Email)}
                  style={getInputStyle('Email')}
                  className="sigup_email_input"
                  placeholder="請輸入您的信箱"
                />
                <label className="annotation">此為登入帳號</label>
              </div>
            </div>

            <div className="input_box signUp row">
              <div className="signUp_box col-12">
                <label className="sigup_label" htmlFor="account">
                  <img
                    style={{ width: '28px', height: '28px' }}
                    className="sigup_icons"
                    src="/assets/images/modal/address.png"
                    alt=""
                  />
                  <span className="label_text">發票地址</span>
                  <span className="redColor">*</span>
                  {errorMessage.CompanyAddress && <span className="error_message">{errorMessage.CompanyAddress}</span>}
                </label>
                <input
                  id="address"
                  name="CompanyAddress"
                  type="address"
                  value={registrationFormData.CompanyAddress}
                  onChange={handleChange}
                  onFocus={() => handleFocus('CompanyAddress')}
                  onBlur={() => handleBlur('CompanyAddress', registrationFormData.CompanyAddress)}
                  style={getInputStyle('CompanyAddress')}
                  className="sigup_address_input"
                  placeholder="請輸入您的發票地址"
                />
                {/* <label className="annotation">此為登入帳號</label> */}
              </div>
            </div>

            <div className="input_box signUp row">
              <div className="signUp_box col-md-6 col-sm-12">
                <label className="sigup_label" htmlFor="account">
                  <img
                    className="sigup_icons"
                    src="/assets/images/modal/key.svg"
                    alt=""
                  />
                  <span className="label_text">會員密碼</span>
                  <span className="redColor">*</span>
                </label>
                <input
                  id="password"
                  name="Password"
                  type="password"
                  value={registrationFormData.Password}
                  onChange={handleChange}
                  onFocus={() => handleFocus('Password')}
                  onBlur={() => handleBlur('Password', registrationFormData.Password)}
                  style={getInputStyle('Password')}
                  className="sigup_input"
                  placeholder="請輸入您的密碼"
                />
                <label className="annotation">
                  密碼需至少8位數，且符合數字、大寫英文字母、小寫英文字母、特殊字元或符號任三項即可
                </label>
              </div>
              <div className="signUp_box col-md-6 col-sm-12">
                <label className="sigup_label" htmlFor="account">
                  <img
                    className="sigup_icons"
                    src="/assets/images/modal/key.svg"
                    alt=""
                  />
                  <span className="label_text">確認會員密碼</span>
                  <span className="redColor">*</span>
                  {errorMessage.ConfirmPassword && <span className="error_message">{errorMessage.ConfirmPassword}</span>}
                </label>
                <input
                  id="confirmPassword"
                  name="ConfirmPassword"
                  type="password"
                  value={confirmPassword}
                  onFocus={() => handleFocus('ConfirmPassword')}
                  onBlur={() => handleBlur('ConfirmPassword', registrationFormData.Password)}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="sigup_input"
                  placeholder="請再次輸入你的密碼"
                />
              </div>
            </div>

            <div className="signUp_links_box">
              <button type="button" onClick={goToLogin} className="backToLogin">
                已經有帳號
              </button>

              <button type="submit" className="signUp_btn">
                {recaptchaLoading || isRegistrationLoaing || isTaxVerifyLoading ? (
                  <div className="btn_loading">
                    <ReactLoading type="spin" color="#00BFFF" height={30} width={30} />
                  </div>
                ) : (
                  '註冊'
                )}
              </button>
            </div>
          </form>
        )}

        {isForgotPassword === true && (
          <form onSubmit={handleForgotPassSubmit} className="input_sec">
            <div className="input_box signUp row">
              <div className="signUp_box forPassword col-12">
                <label className="sigup_label" htmlFor="account">
                  <img
                    className="sigup_icons"
                    src="/assets/images/modal/email.svg"
                    alt=""
                  />
                  <span className="label_text">聯絡人信箱</span>
                  <span className="redColor">*</span>
                </label>
                <input
                  id="email"
                  name="Email"
                  type="email"
                  value={forgotPassFormData.Email}
                  onChange={handleForgotPassChange}
                  className="sigup_email_input"
                  placeholder="請輸入您的信箱"
                />
                <label className="annotation" style={{ marginTop: "6px" }}>
                  我們將向您的電子郵件地址發送重置密碼的連結。
                </label>
                <button type="submit" className="submit_btn forPassword">
                  提交
                </button>
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default CustomModal;
